import React, { useEffect, useCallback, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import onClickOutside from "react-onclickoutside";

import { toggleMainMenu } from "../../store/app";

function MainMenu() {
  const dispatch = useDispatch();
  const isMenuOpen = useSelector((state) => state.app.isMenuOpen);
  const lendingTypes = useSelector((state) => state.auth.lendingTypes);
  const ref = useRef(isMenuOpen);

  useEffect(() => {
    ref.current = isMenuOpen;
  }, [isMenuOpen]);

  MainMenu.clickOutside = useCallback(
    (evt) => {
      ref.current &&
        evt.target.id !== "MainMenuButton" &&
        dispatch(toggleMainMenu());
    },
    [dispatch],
  );

  return (
    <div className="flex flex-col h-full text-left p-6 content-between bg-white overflow-y-auto">
      <div className="py-3 border-b border-solid border-grey-3">
        {Object.values(lendingTypes).map((lending, index) => {
          return (
            <div key={`product-${index}`}>
              <Link
                className={`block hover:font-medium cursor-pointer hover-text-purple-menu no-underline leading-loose p-2 ${
                  lending.active === true
                    ? "text-purple-menu font-medium"
                    : "text-black"
                }
                  ${!lending.isVisible ? "opacity-10 pointer-events-none" : ""}
                `}
                to={`/${lending.urlPath}`}
                onClick={() => dispatch(toggleMainMenu())}
              >
                {lending.name}
              </Link>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default onClickOutside(MainMenu, {
  handleClickOutside: () => MainMenu.clickOutside,
});
